import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('posts/', data));

/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('posts/', { data: ids }));

/**
 * 批量 edit
 */
// export const edits = (datas) => axios.$callAPI(() => axios.patch('posts', datas));

/**
 * 更新岗位信息的某些属性值
 */
// export const edits = (data) => axios.$callAPI(() => axios.patch('posts', data));

/**
 * get postInfo
 */
export const getPostInfo = id => axios.$callAPI(() => axios.get('/posts/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('posts/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('posts/' + id));

/**
 * get list
 */
export const getPostList = data => axios.$callAPI(() => axios.get('posts/search', { params: data }));
